import { useNavigate } from 'react-router-dom'

import { Dialog } from '@factorialco/f0-react/dist/experimental'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onClose: () => void
}

export const CompanyPageNotConfiguredModal = ({ onClose }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  return (
    <Dialog
      open
      onClose={onClose}
      header={{
        type: 'warning',
        title: i18n.t('company_page.not_configured_dialog.title'),
        description: i18n.t('company_page.not_configured_dialog.description'),
      }}
      actions={{
        primary: {
          label: i18n.t('company_page.not_configured_dialog.set_up'),
          onClick: () => navigate(navigation.settings.company_page.fullPath()),
        },
        secondary: {
          label: i18n.t('common.go_back'),
          onClick: onClose,
        },
      }}
    />
  )
}
